import { queryOptions, useQuery } from '@tanstack/react-query';

import { chatSettingsApi } from '../api/chat-settings-api';

import { chatSettingsKeys } from './chat-settings-keys';

export function triggersQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: chatSettingsKeys.triggers(storeId),
    queryFn: () => chatSettingsApi.triggers(storeId),
  });
}

/** The store's triggers (at most 30), by position. */
export function useTriggers(storeId: string) {
  return useQuery(triggersQueryOptions(storeId));
}
